import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Interfaces
import { ILanguage } from '@interfaces/languages.interfaces';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private httpClient = inject(HttpClient);

  public getLanguagesList(): Observable<{ languages: ILanguage[] }> {
    return this.httpClient.get<{ languages: ILanguage[] }>('/languages');
  }
}
